import { Modal } from 'react-bootstrap';
import CloseButton from '../CloseButton';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import useDidMountEffect from '../../utils/useDidMountEffect';
import { getAlbums, setStash } from '../../../redux/actions/stash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NewAlbumModal from './Album/CreateNewAlbumModal';
import { captureException } from '@sentry/react';
import { setAlert } from '../../../redux/actions';
import AlertConfirmModal from "../AlertConfirmModal";
import {s3Link} from "../../utils/constants";

const CopyToFolderModal = ({
    stash,
    show,
    stashSelected,
    albumList,
    showAlbumModal,
    onMessageOrPost = false
}) => {
    const dispatch = useDispatch();

    const [moveAlbumList, setMoveAlbumList] = useState([]);
    const [busy, setBusy] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [modalBody, setModalBody] = useState('');

    const handleClose = () => {
        dispatch(setStash({
            ...stash,
            showMoveFolder: false
        }));
    };

    useEffect(() => {
        if (albumList.length <= 0) {
            dispatch(getAlbums());
        }
    }, []);

    const handleSelectAlbum = () => { };
    const updateMoveAlbumList = (e) => {
        const value = e.target.value;

        if (e.target.checked) {
            setMoveAlbumList([...moveAlbumList, { value }]);
        } else {
            const list = moveAlbumList.filter(element => element.value != value);
            setMoveAlbumList(list);
        }
    };

    const handleNewAlbum = () => {
        // handleCreateNewAlbum();
        // handleClose();
        const payload = {
            showAlbumModal: true
        };

        dispatch(setStash({
            ...stash,
            ...payload
        }));
    };

    const handleAddtoAlbum = () => {
        if (moveAlbumList.length == 0) {
            return false;
        }

        const formData = new FormData();

        moveAlbumList.map((album_id) => {
            formData.append('album_id_list[]', album_id.value);
        });

        stashSelected.map((file, index) => {
            formData.append('media[]', file.media_id);
        });
        setBusy(true);
        axios({
            method: 'post',
            url: '/api/albums/update',
            data: formData,
        })
            .then((response) => {
                const payload = {
                    busy: false,
                    tabselected: 'media',
                    albumAction: '',
                    showMoveFolder: false
                };

                if(!onMessageOrPost) {
                    payload.stashSelected = [];
                }

                dispatch(setStash({
                    ...stash,
                    ...payload,
                }));

                const albumIds = moveAlbumList.map(album => parseInt(album.value));

                const albums = albumList.map(album => {
                    if (albumIds.includes(album.id)) {
                        return album.album_name;
                    }
                }).filter(album => album);

                setBusy(false);
                setModalBody(`Media successfully added to ${albums.join(', ')} album${albums.length > 1 ? 's' : ''}`);
                setShowAlert(true);

                dispatch(getAlbums());
            })
            .catch((error) => {
                console.error({ error });
                setBusy(false);
                dispatch(setAlert({
                    type: 'error',
                    show: true,
                    body: `Something went wrong in adding media to album`
                }));
            });
    };

    useEffect(() => {
        console.log('--', moveAlbumList);
    }, [moveAlbumList]);

    return <React.Fragment>
        <Modal
            show={show}
            onHide={handleClose}
            className="movefolder-modal"
            centered
            size="md"
        >
            <Modal.Header>
                <CloseButton
                    className="close"
                    onClick={handleClose}
                    style={{ position: 'absolute', top: '32px', right: '12px' }}
                />
                <Modal.Title>Copy to Album <span>{stashSelected.length} selected</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table className="table copy-to-album" id="albums_table">
                    <tbody>
                        {
                            albumList && albumList.map((k) => (
                                <tr key={k.id}>
                                    <td className="movefolder-checkbox">
                                        <label>
                                            <input
                                                type="checkbox"
                                                value={k.id}
                                                checked={moveAlbumList.find(element => element.value == k.id)}
                                                onChange={updateMoveAlbumList}
                                            />
                                            <span></span>
                                        </label>
                                    </td>
                                    <td
                                        className="open_album"
                                        onClick={() => { () => handleSelectAlbum(k); }}
                                    >
                                        <b>{k.album_name}</b>
                                        <br />
                                        <span
                                            className="album_stats"
                                        >
                                            <FontAwesomeIcon icon={['fas', 'image']} /> {k.medias_img_count} &nbsp; <FontAwesomeIcon className="album_three_dot" icon={['fas', 'video']} /> {k.medias_video_count}
                                        </span>
                                    </td>
                                    <td className="album-thumb-col open_album">
                                        <div className="thumb-col-img">
                                            {
                                                k.medias.length
                                                    ? <img src={`${s3Link}/${k.medias[k.medias.length - 1]['thumb_path']}`} alt="" />
                                                    : ''
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <div className="moveAlbum-footer-btns">
                    <button
                        className="btn btn-primary btn-rounded"
                        disabled={busy}
                        onClick={handleNewAlbum}><i className="fa-regular fa-plus"></i>  New Album</button>
                    <button
                        className="btn btn-primary btn-rounded"
                        disabled={moveAlbumList.length == 0 || busy}
                        onClick={handleAddtoAlbum}
                    >
                        {
                            busy ? 'Adding...' : 'Add to Album'
                        }
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
        {showAlbumModal && <NewAlbumModal />}
        {showAlert && <AlertConfirmModal show={showAlert} setShow={setShowAlert} modalBody={modalBody} />}
    </React.Fragment>;
};


const mapStateToProps = (state) => {
    return {
        stash: state.stash,
        show: state.stash.showMoveFolder,
        stashSelected: state.stash.stashSelected,
        albumList: state.stash.albums,
        showAlbumModal: state.stash.showAlbumModal,
    };
};

export default connect(mapStateToProps)(React.memo(CopyToFolderModal));
